import React from 'react';

export const URLQueryStringContext = React.createContext<{ value: string }>({ value: window.location.search });
